import API from '.';
export default class UnitOfMeasure {
  /**
   * The primaryUseType dimension table for UDM
   * @param {string} uomCode
   * @param {string} uomName
   * @param {string} isoUomCode
   * @param {string} uomForCommercialUsageCode

   * @param {string} uomForTechnicalUsageCode
   * @param {string} uimDimensionCode
   * @param {string} uomSapCode
   * @param {number} uomConversionToSiUnitNumeratorValue
   * @param {number} uomConversionToSiUnitDenominatorValue
   * @param {number} uomConversionToSiUnitExponentValue
   * @param {number} uomConversionToSiUnitConstantValue
   * @param {string} uomForTechnicalUsageInSimplifiedASCIICode
   * @param {string} interestToLabIndicator
   **/

  constructor({
    uomCode,
    uomName,
    isoUomCode,
    uomForCommercialUsageCode,
    uomForTechnicalUsageCode,
    uomDimensionCode,
    uomSapCode,
    uomConversionToSiUnitNumeratorValue,
    uomConversionToSiUnitDenominatorValue,
    uomConversionToSiUnitExponentValue,
    uomConversionToSiUnitConstantValue,
    uomForTechnicalUsageInSimplifiedASCIICode,
    interestToLabIndicator,
  }) {
    this.UomCode = uomCode;
    this.UomName = uomName;
    this.IsoUomCode = isoUomCode;
    this.UomForCommercialUsageCode = uomForCommercialUsageCode;
    this.UomForTechnicalUsageCode = uomForTechnicalUsageCode;
    this.UomDimensionCode = uomDimensionCode;
    this.UomSapCode = uomSapCode;
    this.UomConversionToSiUnitNumeratorValue = uomConversionToSiUnitNumeratorValue;
    this.UomConversionToSiUnitDenominatorValue = uomConversionToSiUnitDenominatorValue;
    this.UomConversionToSiUnitExponentValue = uomConversionToSiUnitExponentValue;
    this.UomConversionToSiUnitConstantValue = uomConversionToSiUnitConstantValue;
    this.UomForTechnicalUsageInSimplifiedASCIICode =
      uomForTechnicalUsageInSimplifiedASCIICode;
    this.InterestToLabIndicator = interestToLabIndicator;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/UnitOfMeasure');
    return data.map((d) => new UnitOfMeasure(d));
  }
  static async get(id) {
    const api = await API();
    const { data } = await api.get(`UnitOfMeasure/${id}`);
    return new UnitOfMeasure(data);
  }
}
